import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fullNameAction } from 'redux/actions'
import styles from './ContactInformation.module.scss'

const FullName = ({ t, validateFullName, validateMasterNumber, fullNameError, fullNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const fullName = useSelector((state) => state.app.fullName)

  const handleFullName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(fullNameAction(name))
      // validateFullName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurFullName = (e) => {
    try {
      let name = e.currentTarget.value.trim()
      SetIsFocussed(false)
      dispatch(fullNameAction(name))
      validateFullName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        fullNameValid === true
          ? fullName !== '' && 'form-group has-success'
          : fullNameValid === false && 'form-group ns-form-group-message-error',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="FullName">
        <b>{t('contact_info.full_name')}</b>
      </label>
      {fullNameValid === false && (
        <div className="ns-form-error-container has-error error-msg-align">
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(fullNameError)}</div>
        </div>
      )}
      <input
        autoFocus
        type="text"
        id="FullName"
        className={'form-control ' + styles['field_width_25_em'] + ' ' + styles['uppercase-text']}
        value={fullName}
        onChange={handleFullName}
        // onBlur={onBlurFullName}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="150"
      />
      {fullNameValid === true && fullName !== '' && (
        <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
      )}
    </div>
  )
}

export default withTranslation('common')(FullName)
